import { render } from "./DashboardQuotes.vue?vue&type=template&id=6a672664"
import script from "./DashboardQuotes.vue?vue&type=script&lang=js"
export * from "./DashboardQuotes.vue?vue&type=script&lang=js"

import "./DashboardQuotes.vue?vue&type=style&index=0&id=6a672664&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__